import React, { Fragment } from 'react';
import $ from 'jquery';
import useLanguage from '../hooks/useLanguage';
import usePrivateMessage from '../hooks/usePrivateMessage';
import NavItemDropdown from '../components/navItemDropdown';
import Label from '../utils/label';
import Config from '../utils/config';
import * as athenaPopups from '../utils/athenaPopups';
import { execJS } from '../utils/utils';
import PopupKycReupload from '../AthenaComponent/popupKycReupload';
import { createRoot } from 'react-dom';

const showTransferFunds = Config.appConfig.getAccountMenu && JSON.parse(Config.appConfig.getAccountMenu).ShowTransferFunds;

export default function MyAccount(props) {
    const actStatus = Config.appConfig.ActStatus;

    const {
        privateMessageCount,
        openPrivateMessage
    } = usePrivateMessage();

    async function logout() {
        athenaPopups.closeAll();
        execJS(await Promise.resolve($.get('logout.aspx')));
    }

    function popWin(e) {
        props.openDepositPage(e.currentTarget.dataset.type, Config.appConfig.SiteTitle);
    }

    function showKycUploadModal(){
        props.popupDiv(7);
    }

    const openRulesPage = event => {
        event.preventDefault();
        window.open(
            Config.appConfig.RandRURL,
            'rule-win',
            'height=679,width=1000,toolbar=no,menubar=no,scrollbars=yes,resizable=no,location=no,status=no'
        );
    };

    return (
        <NavItemDropdown
            dropdownButton={<MyAccountButton userName={Config.appConfig.UserName} />}
            dropdownMenuClassName="myaccount"
        >
            <a className="dropdown-item icon-account" href="javascript:void(0)" data-type="3" onClick={popWin}>
                <span>{Label.lbl_ManageAccount}</span>
            </a>

            {/* Sabademo KYC Verification */}
            {Config.appConfig.SiteID === '4245600' && Config.appConfig.KycStatus == 0 && (
                <a class="dropdown-item icon-uncertified" href="javascript:void(0)" onClick={showKycUploadModal}>
                    <span>{Label.lbl_SabaDemoKYC01}</span>
                    <i class="icon-chevron-right"></i>
                </a>
            )}
            {Config.appConfig.SiteID === '4245600' && Config.appConfig.KycStatus != 0 && (
                <a class="dropdown-item icon-certified" href="javascript:void(0)">
                    <span>{Label.lbl_SabaDemoKYC01}</span>
                </a>
            )}

            {actStatus === '2' && (
                <a className="dropdown-item icon-message" href="javascript:void(0)" onClick={openPrivateMessage}>
                    <span>{Label.lbl_Message}</span>
                    {privateMessageCount > 0 && <div className="alert">{privateMessageCount}</div>}
                </a>
            )}
            <div className="dropdown-divider" />
            <a className="dropdown-item icon-transaction" href="javascript:void(0)" data-type="0" onClick={popWin}>
                <span>{Label.lbl_TransactionTitle}</span>
            </a>
            {actStatus === '2' && (
                <Fragment>
                    {showTransferFunds && (
                        <a className="dropdown-item icon-transfer" href="javascript:void(0)" data-type="2" onClick={popWin}>
                            <span>{Label.lbl_TransferFunds}</span>
                        </a>
                    )}
                    <a className="dropdown-item icon-betList" href="javascript:void(0)" data-type="4" onClick={popWin}>
                        <span>{Label.lbl_betlist}</span>
                    </a>
                    <a className="dropdown-item icon-statement" href="javascript:void(0)" data-type="5" onClick={popWin}>
                        <span>{Label.lbl_statement}</span>
                    </a>
                    <a className="dropdown-item icon-result" href="javascript:void(0)" data-type="6" onClick={popWin}>
                        <span>{Label.lbl_result}</span>
                    </a>
                </Fragment>
            )}

            <a 
                className="dropdown-item icon-rnr"
                href="#"
                onClick={openRulesPage}
            >
                {Label.lbl_SportsRules}
            </a>

            <div className="dropdown-divider" />
            <LanguageDropdonwItem />
            <a className="dropdown-item icon-logout" href="javascript:void(0)" onClick={logout}>
                <span>{Label.lbl_Logout}</span>
            </a>
        </NavItemDropdown>
    );
}


function MyAccountButton(props) {
    return (
        <Fragment>
            <i className="icon-account" />
            {props.userName}
        </Fragment>
    );
}

function LanguageDropdonwItem() {
    const {
        selectedLang,
        langList,
        selectLang
    } = useLanguage();

    return (
        <div className="dropdown-item icon-earth" href="javascript:void(0)">
            <span>{Label.lbl_language}</span>
            <i className="icon-chevron-right" />
            <div className="dropdown-menu" data-tag="tagLanguageList" onClick={selectLang}>
                {langList.map(lang => (
                    <a
                        key={lang.id}
                        className={`dropdown-item ${selectedLang === lang.id ? 'current' : ''}`}
                        href="javascript:void(0)"
                        title={lang.name}
                        data-id={lang.id}
                    >
                        {lang.name}
                    </a>
                ))}
            </div>
        </div>
    );
}